import { useState, useEffect } from "react";
import "./Tabs.css";

export default function Tabs({
  tabs,
  defaultTabId,
  onTabChange
}) {

  const getInitialTab = () => {
    if (defaultTabId) {
      const exists = tabs.find(tab => tab.id === defaultTabId);
      if (exists) return defaultTabId;
    }
    return tabs[0]?.id;
  };

  const [activeTabId, setActiveTabId] = useState(getInitialTab);

  useEffect(() => {
    if (onTabChange) {
      onTabChange(activeTabId);
    }
  }, [activeTabId, onTabChange]);

  const activeTab = tabs.find(tab => tab.id === activeTabId);

  return (
    <div className="tabs-container">
      <div className="tabs-header">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`tab-button ${
              activeTabId === tab.id ? "active" : ""
            }`}
            onClick={() => setActiveTabId(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="tabs-content">
        {activeTab?.content}
      </div>
    </div>
  );
}